import { AbstractSeer, AbstractInstanceSeer, AbstractStatefulCbInstanceSeer, setStatefulCbInstanceSeerSymbols } from '../../types/lux'
import { deriveValues } from './derive'

const Seer = AbstractSeer
export default Seer

// export class HoardingSeer extends AbstractSeer {
//   constructor(){
//     super()
//     this.hoard = null
//   }
// }

// /** @constructor @extends {Seer} @suppress {checkTypes} */ function _Seer() {}
// AbstractSeer.__implement(
//   _Seer.prototype = /** @type {!Seer} */ ({
//   }),
// )

export class InstanceSeer extends AbstractInstanceSeer {}

export const StatefulCbInstanceSeer = AbstractStatefulCbInstanceSeer
// export class StatefulCbInstanceSeer extends AbstractStatefulCbInstanceSeer {}

/** @constructor @extends {AbstractStatefulCbInstanceSeer} @suppress {checkTypes} */ function _StatefulCbInstanceSeer() {}
AbstractStatefulCbInstanceSeer.__implement(
  _StatefulCbInstanceSeer.prototype = /** @type {!AbstractStatefulCbInstanceSeer} */ ({
    __$see({data}) {
      const {
        asIStatefulCbInstanceSeer: { enableHoarding }, asIInstanceSeer: { instance },
      } = this
      // hoard
      if (!enableHoarding) {
        /** @type {!Function} */ (data).call(instance)
        return
      }
      if (!this.hoard) {
        const hoard = new Set()
        setStatefulCbInstanceSeerSymbols(this, {
          _hoard: hoard,
        })
        setTimeout(() => {
          // const { asIStatefulCbInstanceSeer: { hoard } } = this
          setStatefulCbInstanceSeerSymbols(this, {
            _hoard: null,
          })
          for (const d of hoard) {
            /** @type {!Function} */ (d).call(instance)
          }
          hoard.clear()
        }, 1)
      }
      this.hoard.add(/** @type {!Function} */ (data))
    },
  }),
)

export class DeriverSeer extends InstanceSeer {
  constructor() {
    super()
    this.derivedProps = {}
    this.cb = null
    /** @type {Set<string>} */
    this.hoard = null
  }
  __$see({data:key}) {
    let{hoard}=this
    if (!hoard) {
      hoard=new Set()
      this.hoard = hoard
      setTimeout(() => {
        this.hoard = null
        const values=deriveValues(this.derivedProps,this.instance,hoard.values())
        if(Object.keys(values).length)this.cb(values)
      },1)
    }
    hoard.add(key)
  }
}